import React from "react";
import { CiImageOn } from "react-icons/ci";
import { Link } from "react-router-dom";
import { getRole } from "../../utils/GetRole";

export const SketchDetails = ({ name, description, sketchMedia,isShowDetail,isDesignSection,portalFeeRatio,artistFeeRatio,artistPrize,contestId,isResultUploads, sketchData, contestData}) => {
  const fileUrl = process.env.REACT_APP_FILE_URL;
  const role=getRole();

  // console.log("sketchData");
  // console.log(sketchData);
  // console.log("contestData");
  // console.log(contestData);

  

// Function to extract unique artists from contest detail
const extractArtists = (contestDetail) => {
  if (!contestDetail?.participants || contestDetail.participants.length === 0) {
    return [];
  }

  // Extract unique artists from participants
  const artistsMap = new Map();
  
  contestDetail.participants.forEach((participant) => {
    if (participant.artist_id && participant.artist) {
      artistsMap.set(participant.artist_id, {
        id: participant.artist.id,
        name: participant.artist.name,
        email: participant.artist.email,
        profileImage: participant.artist.profile_image,
        participantId: participant.id,
        joinedAt: participant.created_at,
        status: participant.is_accept == '1' ? 'Accepted' : participant.is_accept == '3' ? 'Requested' : 'Rejected',
      });
    }
  });

  return Array.from(artistsMap.values());
};

  return (
    <div className="w-full flex flex-col">
      <div className="w-full border border-border_color rounded-[14px] p-2 sm:p-4 ">
        {/* Title */}
        <h2 className="text-start text-black text-[20px] font-bold font-grotesk mt-1 ">
          Sketch Type
        </h2>

        {/* Sketch Character Field */}
        <div className="mt-2">
          <input
            type="text"
            value={name}
            readOnly
            className="w-full px-[14px] py-2 bg-transparent border text-black text-xs font-medium font-grotesk border-border_color rounded-md outline-none"
            placeholder="Character designer"
          />
        </div>

        {/* Uploaded Images */}
        <h2 className="text-start text-black text-[20px] font-bold font-grotesk mt-4">
          Uploaded Images
        </h2>
        <div className="w-full flex flex-wrap gap-3 mt-2">
          {sketchMedia && sketchMedia.length > 0 ? (
            sketchMedia.map((media) => (
              <div
                key={media.id}
                className="relative flex-1  h-[174px]"
              >
                <div className="w-full h-full bg-white rounded-xl overflow-hidden flex items-center justify-center border border-gray-200">
                  {media.file_type === "image" ? (
                    <img
                      src={`${fileUrl}${media.file_name}`}
                      alt={`Media ${media.id}`}
                      className="w-full h-full object-cover"
                    />
                  ) : (
                    <CiImageOn className="text-8xl text-gray-300" />
                  )}
                </div>
              </div>
            ))
          ) : (
            <CiImageOn className="text-8xl text-gray-300" />
          )}
        </div>
      </div>


   

{contestData ? (
  <div className="w-full border border-border_color rounded-[14px] flex flex-col items-center mt-4">
   
   

    {/* Artists List Section */}
    {contestData?.participants && contestData.participants.length > 0 && (
      <div className="w-full px-4 pb-5 mt-4">
        <h3 className="text-black text-[18px] font-bold font-grotesk mb-3">
          Participating Artists ({contestData.participants.length})
        </h3>
        
        <div className="flex flex-col gap-3">
          {extractArtists(contestData).map((artist) => (
            <div
              key={artist.id}
              className="flex items-center gap-3 p-3 bg-white border border-border_color rounded-lg"
            >
              {/* Artist Profile Image
              <div className="w-12 h-12 rounded-full overflow-hidden bg-gray-200 flex-shrink-0">
                {artist.profileImage ? (
                  <img
                    src={artist.profileImage}
                    alt={artist.name}
                    className="w-full h-full object-cover"
                  />
                ) : (
                  <div className="w-full h-full flex items-center justify-center text-gray-500 font-bold">
                    {artist.name?.charAt(0).toUpperCase()}
                  </div>
                )}
              </div> */}

              {/* Artist Info */}
              <div className="flex-1">
                <p className="text-black font-bold font-grotesk text-[16px]">
                  {artist.name}
                </p>
                {artist.email && (
                  <p className="text-[#848484] font-medium font-grotesk text-[12px]">
                    {artist.email}
                  </p>
                )}
              </div>

              {/* Optional: Joined Date */}
              {artist.joinedAt && (
                <div className="text-right">
                  <p className="text-[#848484] font-medium font-grotesk text-[11px]">
                    {artist.status}
                  </p>
                  <p className="text-[#696565] font-bold font-grotesk text-[12px]">
                    {new Date(artist.joinedAt).toLocaleDateString()}
                  </p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    )}
  </div>
) : (
  ""
)}
    {isShowDetail?
      <div className="w-full border border-border_color rounded-[14px] flex flex-col  items-center mt-4  ">
        <h2 className="w-full text-start text-black text-[20px] font-bold font-grotesk mt-5 px-4">Additional Instructions</h2>

        <textarea
          rows={7}
          value={description}
          readOnly


          className="w-full  resize-none px-4 py-1 rounded-xl bg-transparent text-[16px] font-grotesk text-[#696565] font-medium"

        ></textarea>
      </div>
      :''}

 {isDesignSection?
      <div className="w-full border border-border_color rounded-[14px] flex flex-col  items-start mt-4 p-6 ">
         <h3 className="font-grotesk text-black font-bold text-xl tracking-wide">Commissions</h3>
         <p className="font-grotesk font-medium text-[16px] tracking-wide mt-1">You will receive <span className="font-bold text-primary">{artistFeeRatio}%</span> of the contest prize, while <span className="font-bold text-primary">{portalFeeRatio}%</span> will cover the portal fees.</p>
         <hr className="h-2 w-full text-[#D2D2D2] mt-2" />
         <p className="font-grotesk font-bold text-[16px] text-primary tracking-wide mt-1">Total Prize:  <span className="font-medium text-[#696565]">${artistPrize}</span></p>
      </div>
    :''}

      {/* {isResultUploads==1 && role=='admin' || role=='user'?
<div className="w-full border border-border_color rounded-[14px]  mt-4 px-5 py-4 flex items-center justify-between flex-wrap gap-2 ">
         <h3 className="font-grotesk text-black font-bold text-lg tracking-wide ">Results Upload by Artists</h3>
      <Link to={`/admin/contest-results/${contestId}`} className=" font-medium font-grotesk text-xs py-3 px-5 rounded-[10px] text-white bg-primary tracking-wide mt-1">
  See Results
</Link>

      </div>
:''} */}


{isResultUploads === 1 && (role === 'admin' || role === 'user' || role === 'artist') ? (
  <div className="w-full border border-border_color rounded-[14px] mt-4 px-5 py-4 flex items-center justify-between flex-wrap gap-2">
    <h3 className="font-grotesk text-black font-bold text-lg tracking-wide">
      Results Upload by Artists
    </h3>

    <Link
      to={`/${role}/contest-results/${contestId}`}
      className="font-medium font-grotesk text-xs py-3 px-5 rounded-[10px] text-white bg-primary tracking-wide mt-1"
    >
      See Results
    </Link>
  </div>
) : null}

    </div>
  );
};
